import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    faqStore: {
      roles: [],
    },
};

const getters = {
  getRoles: (state) => state.faqStore.roles,
};

const mutations = {
  setRoles: (state, roles) => (state.faqStore.roles = roles), // Needed to grant access to file NS-10117 VS
};

const actions = {
  async getAvailableFaqFiles( context, data ) {
    return await axios.get(`${backendUrl()}/getFAQs`,
    {
        params: {
            userLevel: data.userLevel
        },
        headers: { 'Authorization': "bearer " + vuecookie.get('token') },

    })
    .then(response => {
        return response.data
    })
  },
};



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


